import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Icons from "../../scss/prh-icon-sprite.svg";

const Accordion = (props) => {
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="mb-2">
      <h4 className="mb-0">
        <button
          type="button"
          className="btn btn-secondary mb-0"
          style={{ width: "100%", textAlign: "left" }}
          onClick={handleClick}
          id={"accordion-btn-" + props.id}
          aria-expanded={expanded}
          aria-label={props.title}
        >
          <Row>
            <Col xs={11} style={{ textAlign: "left", padding: "0px" }}>
              <span>{props.title}</span>
            </Col>
            <Col xs={1} style={{ textAlign: "right", padding: "0px" }}>
              <svg alt="" className="prh-icon">
                <use xlinkHref={`${Icons}#chevron-down`}></use>
              </svg>
            </Col>
          </Row>
        </button>
      </h4>
      {expanded ? (
        <div
          aria-labelledby={"accordion-btn-" + props.id}
          id={props.id}
          style={{ border: "1px solid gray", borderColor: "LightGray" }}
          className={"d-print-none"}
        >
          {props.content}
        </div>
      ) : null}
      <div
        role="tabpanel"
        style={{ border: "1px solid gray", borderColor: "LightGray" }}
        className={"d-none d-print-block"}
      >
        {props.content}
      </div>
    </div>
  );
};

export default Accordion;
